import { useOpenableElementIsOpen } from '../../hooks/useOpenableElement';
import useOpenAwaiter from '../../hooks/useOpenAwaiter';

import AudioOutputTestDialog, {
  AudioOutputTestDialogProps,
} from './AudioOutputTestDialog';

import ChatThemeProvider from '@/providers/ChatThemeProvider';

const AudioOutputTestDialogEx = (
  props: Omit<AudioOutputTestDialogProps, 'open'> & { isOpenKey: string }
) => {
  const isOpen = useOpenableElementIsOpen(props.isOpenKey);
  return (
    <ChatThemeProvider>
      <AudioOutputTestDialog open={isOpen} {...props} />
    </ChatThemeProvider>
  );
};

const useAudioOutputTestDialog = () => {
  const openAwaiter = useOpenAwaiter<boolean>();
  return {
    open: (props?: Omit<AudioOutputTestDialogProps, 'open' | 'onClose'>) =>
      openAwaiter.open(
        <AudioOutputTestDialogEx
          isOpenKey={openAwaiter.key}
          onClose={openAwaiter.close}
          {...props}
        />
      ),
  };
};
export default useAudioOutputTestDialog;
